import { Shop_IaEntityCopy } from '@app/data/shop-bff';
import { constructShopTagSlug, localizedPath } from '@app/utils/common';
import { getSafeUrl } from '@redbubble/utils/getSafeUrl';
import { Tag } from 'pages/i/types';
import { TrendingTag } from 'types/monolith/types';
import { BubbleItem } from 'types/shop-bff/types';
import { URLS } from '../../../urls';

// TODO: supply category landing pages /g/ we support
const CATEGORY_TEMPLATE_SUPPORTED_IA_CANONICAL_FORM = new Set(['t-shirts']);

export const truncateTag = (tag: string): string => {
  const maxChar = 128;

  return tag && tag.length > maxChar
    ? tag.substring(0, maxChar - 3).concat('...')
    : tag;
};

export const allProductsTags = (
  tags: string[],
  linkBackTags: string[] | undefined | null,
  locale: string
): Tag[] => {
  const allTags = tags.concat(linkBackTags || []);
  return allTags.map((tag) => {
    const formattedLabel = truncateTag(tag);
    const slug = constructShopTagSlug(tag, '');
    return {
      name: tag,
      linkSuffix: '',
      linkTitle: tag,
      linkLabel: formattedLabel,
      slug: localizedPath(locale, slug),
    };
  });
};

export const productTagList = (
  tags: string[],
  iaEntityCopy: Shop_IaEntityCopy | null,
  locale: string
): Tag[] | null => {
  if (!iaEntityCopy) return null;
  const pluralDisplayName = iaEntityCopy.pluralDisplayName.toLowerCase();
  return tags.map((tag) => {
    const formattedLabel = truncateTag(tag);
    const slug = constructShopTagSlug(tag, iaEntityCopy.canonicalForm);
    return {
      name: tag,
      linkSuffix: iaEntityCopy.canonicalForm,
      linkTitle: `${tag} ${iaEntityCopy.label}`,
      linkLabel: `${formattedLabel} ${pluralDisplayName}`,
      slug: localizedPath(locale, slug),
    };
  });
};

export const getDiscoveryUnitBubbles = (
  tags: string[],
  iaEntityCopy: Shop_IaEntityCopy | null,
  locale: string
): BubbleItem[] | undefined => {
  return productTagList(tags, iaEntityCopy, locale)?.map((tag: Tag) => {
    return {
      title: tag.linkLabel,
      url: tag.slug,
    };
  });
};

export const categoryPagePath = (
  canonicalForm: string,
  locale: string
): string => {
  return CATEGORY_TEMPLATE_SUPPORTED_IA_CANONICAL_FORM.has(canonicalForm)
    ? localizedPath(locale, `${URLS.CONFIGURED_LANDING_PAGE}/${canonicalForm}`)
    : localizedPath(
        locale,
        `${URLS.SEARCH_CONTEXT_LANDING_PAGE}/${canonicalForm}`
      );
};

export function convertTrendingTagToTag(trendingTag: TrendingTag): Tag | null {
  const locale = 'en-US'; // Hard coded as trending data returns blank if any other locale currently.

  // check for parsable url and if not return null
  const url = getSafeUrl(trendingTag.url);
  const path = url ? url.pathname : null;

  if (!path) {
    return null;
  }

  return {
    name: trendingTag.tag,
    linkSuffix: trendingTag.url,
    linkTitle: `Search for ${trendingTag.tag}`,
    linkLabel: trendingTag.tag,
    slug: localizedPath(locale, path),
  };
}
